import React, { lazy, Suspense, useState } from "react";

const LazyNewLeaderBoardMap = lazy(() => import("./NewLeaderBoardMap"));

export function hasChallengeMap(mapName) {
  if (typeof mapName === "string") {
    return mapName.trim().length > 0;
  }
  return Boolean(mapName);
}

export default function ChallengeMapSection({
  racersData,
  ownerData,
  mapName,
  MapComponent = LazyNewLeaderBoardMap,
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!hasChallengeMap(mapName)) {
    return null;
  }

  function toggleMap() {
    setIsExpanded((currentValue) => !currentValue);
  }

  return (
    <section className="mb-6" aria-label="Challenge map">
      <div className="flex flex-col items-center text-center">
        {!isExpanded ? (
          <button
            type="button"
            className="group block w-full max-w-[380px] overflow-hidden rounded-2xl bg-transparent p-0 transition hover:-translate-y-0.5 hover:drop-shadow-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
            aria-controls="challenge-map-panel"
            aria-expanded="false"
            aria-label="Load live map"
            onClick={toggleMap}
          >
            <img
              src={`${process.env.PUBLIC_URL}/img/load-live-map.png`}
              alt=""
              className="block h-auto w-full"
            />
          </button>
        ) : (
          <button
            type="button"
            className="rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm transition hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2"
            aria-controls="challenge-map-panel"
            aria-expanded="true"
            onClick={toggleMap}
          >
            Hide live map
          </button>
        )}
      </div>

      {isExpanded && (
        <div id="challenge-map-panel" className="mt-4 overflow-hidden rounded-xl border border-slate-200 shadow-sm">
          <Suspense fallback={<p role="status" className="m-0 p-6 text-center text-sm text-slate-600">Loading live map...</p>}>
            <MapComponent racersData={racersData} ownerData={ownerData} mapName={mapName} />
          </Suspense>
        </div>
      )}
    </section>
  );
}
